import React, { useCallback } from "react";
import ModalWrapper from "..";
import { useDeleteUser } from "../../../hooks/user/mutation";
import useAuthStore from "../../../store/Auth";
import { Button } from "../../button";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

interface DeleteUserModalProps {
  userId: number;
  isOpen: boolean;
  onOpenChange: () => void;
}

const DeleteUserModal = ({
  userId,
  isOpen,
  onOpenChange,
}: DeleteUserModalProps) => {
  const { t } = useTranslation();

  const user = useAuthStore((state) => state.user);

  const { mutateAsync: DeleteUser, isPending: isDeleteUserLoading } =
    useDeleteUser();

  const handleDeleteUser = useCallback(async () => {
    try {
      const body = {
        Id: userId,
        N_UserId: user?.user_id,
      };
      await DeleteUser(body);
      toast.success(t("userDeleted"));
    } catch (error) {
      toast.error(t("somethingWentWrong"));
    } finally {
      onOpenChange();
    }
  }, [DeleteUser, onOpenChange, t, user?.user_id, userId]);

  return (
    <ModalWrapper isOpen={isOpen} onOpenChange={onOpenChange}>
      <div className="flex flex-col gap-8 justify-center items-center">
        <p className="text-lg md:text-2xl font-medium">
          {t("confirmDeleteUser")}
        </p>

        <div className="flex gap-1 items-center">
          <Button
            onClick={handleDeleteUser}
            isLoading={isDeleteUserLoading}
            className=" bg-red-600 hover:bg-red-700"
          >
            {t("delete")}
          </Button>

          <Button onClick={onOpenChange}>{t("close")}</Button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default React.memo(DeleteUserModal);
